
import { Component, Vue } from 'vue-property-decorator'
import { CourseModule } from '../../store/modules/course'
import BasicInfo from '../../components/studentDeatil/basic-info.vue'
import CourseRecord from '../../components/studentDeatil/course-record.vue'
import SignRecord from '../../components/studentDeatil/sign-record.vue'
import ConsumerRecord from '../../components/studentDeatil/consumer-record.vue'
import StudentAble from '../../components/studentDeatil/student-able.vue'

@Component({
  name: 'package',
  components: { BasicInfo, CourseRecord, SignRecord, ConsumerRecord, StudentAble }
})
export default class extends Vue {
  org_id: string = 'd06455545e6d4b929f4fbacbdc93dd24'
  activeName: string = 'first'
  capability: any = ''
  studentId: any = ''
  is_updata: boolean = false
  mounted() {
    this.studentId = this.$route.query.student_id
  }

  getCapability(val) {
    let data = {
      show_student_value: this.capability
    }
    this.update(data)
  }

  getDetails(val) {
    this.capability = val.show_student_value
    this.is_updata = false
  }
  async update(data) {
      data.student_id = this.studentId
      const res: any = await CourseModule.studentUpdate(data)
      if (res.code === 200) {
        this.$message({
          type: 'success',
          message: res.message
        })
        this.is_updata = true
      } else {
        this.$message.error(res.message)
      }
    }
}
